import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { TRUST_URL } from "../lib/constants";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-500 ${
        scrolled ? "bg-ink/90 backdrop-blur-xl border-white/10" : "bg-transparent border-transparent"
      }`}
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between gap-4">
        <a href="/" className="group" data-testid="nav-logo-link">
          <div className="font-display text-lg sm:text-xl tracking-[0.14em] text-cream leading-none">
            IRON GATE <span className="text-gold">CONSULTING</span>
          </div>
          <div className="text-[8px] sm:text-[9px] tracking-[0.28em] text-cream/45 mt-1.5 uppercase">
            Formerly Assets Secure USA · Powered by Echo Holding Ventures Inc.
          </div>
        </a>
        <div className="flex items-center gap-3 sm:gap-5">
          <div
            className="hidden md:flex items-center gap-2 border border-gold/35 bg-gold/10 text-gold text-[10px] tracking-[0.22em] font-semibold px-4 py-2 rounded-full"
            data-testid="veteran-badge"
          >
            <ShieldCheck size={13} strokeWidth={2.2} />
            U.S. VETERAN OWNED AND OPERATED
          </div>
          <a
            href={TRUST_URL}
            data-testid="nav-get-started-btn"
            className="bg-gold text-ink text-xs sm:text-sm font-bold tracking-[0.1em] uppercase px-5 sm:px-7 py-3 rounded-full hover:bg-goldlight transition-colors duration-300 whitespace-nowrap shadow-[0_0_28px_rgba(201,162,60,0.35)]"
          >
            Get Started
          </a>
        </div>
      </div>
    </motion.header>
  );
};
